const ProcurementTenderType = {
  ADD_NEW_BID_PARAMETER_ACTION: 'ADD_NEW_BID_PARAMETER_ACTION',

  ADD_NEW_LANE_BUTTON: 'ADD_NEW_LANE_BUTTON',

  CREATE_TENDER_COPY: 'CREATE_TENDER_COPY',
  CREATE_TENDER_COPY_FAIL: 'CREATE_TENDER_COPY_FAIL',
  CREATE_TENDER_COPY_RESET: 'CREATE_TENDER_COPY_RESET',
  CREATE_TENDER_COPY_SUCCESS: 'CREATE_TENDER_COPY_SUCCESS',

  GET_PROCUREMENT_ADD_LANE_INFORMATION: 'GET_PROCUREMENT_ADD_LANE_INFORMATION',
  GET_PROCUREMENT_ADD_LANE_INFORMATION_FAIL: 'GET_PROCUREMENT_ADD_LANE_INFORMATION_FAIL',
  GET_PROCUREMENT_ADD_LANE_INFORMATION_SUCCESS: 'GET_PROCUREMENT_ADD_LANE_INFORMATION_SUCCESS',

  GET_PROCUREMENT_HISTORICAL_BID_LIST: 'GET_PROCUREMENT_HISTORICAL_BID_LIST',
  GET_PROCUREMENT_HISTORICAL_BID_LIST_FAIL: 'GET_PROCUREMENT_HISTORICAL_BID_LIST_FAIL',
  GET_PROCUREMENT_HISTORICAL_BID_LIST_REQUEST_RESET: 'GET_PROCUREMENT_HISTORICAL_BID_LIST_REQUEST_RESET',
  GET_PROCUREMENT_HISTORICAL_BID_LIST_SUCCESS: 'GET_PROCUREMENT_HISTORICAL_BID_LIST_SUCCESS',

  GET_PROCUREMENT_LANE_INFORMATION: 'GET_PROCUREMENT_LANE_INFORMATION',
  GET_PROCUREMENT_LANE_INFORMATION_FAIL: 'GET_PROCUREMENT_LANE_INFORMATION_FAIL',
  GET_PROCUREMENT_LANE_INFORMATION_REQUEST_RESET: 'GET_PROCUREMENT_LANE_INFORMATION_REQUEST_RESET',
  GET_PROCUREMENT_LANE_INFORMATION_SUCCESS: 'GET_PROCUREMENT_LANE_INFORMATION_SUCCESS',
  GET_PROCUREMENT_TENDER_LIST: 'GET_PROCUREMENT_TENDER_LIST',
  GET_PROCUREMENT_TENDER_LIST_FAIL: 'GET_PROCUREMENT_TENDER_LIST_FAIL',
  GET_PROCUREMENT_TENDER_LIST_REQUEST_RESET: 'GET_PROCUREMENT_TENDER_LIST_REQUEST_RESET',
  GET_PROCUREMENT_TENDER_LIST_SUCCESS: 'GET_PROCUREMENT_TENDER_LIST_SUCCESS',

  GET_TENDER_CARRIER_LIST: 'GET_TENDER_CARRIER_LIST',
  GET_TENDER_CARRIER_LIST_FAIL: ' GET_TENDER_CARRIER_LIST_FAIL',
  GET_TENDER_CARRIER_LIST_REQUEST_RESET: ' GET_TENDER_CARRIER_LIST_REQUEST_RESET',
  GET_TENDER_CARRIER_LIST_SUCCESS: ' GET_TENDER_CARRIER_LIST_SUCCESS',

  RESET_ACTIVE_TENDER_ITEM: 'RESET_ACTIVE_TENDER_ITEM',
  SET_ACTIVE_TENDER_ITEM: 'SET_ACTIVE_TENDER_ITEM',
  UPDATE_PROCUREMENT_TENDER_INFO_REQUEST: 'UPDATE_PROCUREMENT_TENDER_INFO_REQUEST',

  UPDATE_TENDER_PROGRESS: 'UPDATE_TENDER_PROGRESS',
};

// biome-ignore lint/style/noDefaultExport: TODO: fix
export default ProcurementTenderType;
